/*
 * SDK Modules Barrel Export
 * Re-exports all SDK classes, interfaces, and types
 */

// BatchSdk exports
export {
  BatchSdk,
  type BatchIdResponse,
  type BatchDocumentKeyField,
  type BatchDocumentRequest,
  type CreateBatchRequest,
  type BatchStatistics,
  type BatchDocumentResponse,
  type BatchResponse,
  type BatchListResponse,
  type BulkCreateBatchDocumentRequest,
  type BatchDocumentListResponse,
  type ListBatchesParams,
  type UpdateBatchRequest,
  type UpdateBatchDocumentRequest,
  type PrivilegeDepartment,
  type PrivilegeContext,
  type Privilege
} from './batchSdk';

// DocTypeMappingSdk exports
export {
  DocTypeMappingSdk,
  type GetDocTypeMappingParams,
  type Field,
  type FieldMapping,
  type CreateDocTypeMappingRequest,
  type UpdateDocTypeMappingRequest,
  type DocTypeMappingResponse,
  type KeyField,
  type MapRequest,
  type MapItem,
  type MapResponse
} from './docTypeMappingSdk';

// DocumentAnalysisSdk exports
export {
  DocumentAnalysisSdk,
  type ExtractionStartResponse,
  type ExtractionStatusResponse
} from './documentAnalysisSdk';

// DocumentManagementSdk exports
export {
  DocumentManagementSdk,
  type ContentMetadata,
  type DocumentResponse,
  type DocumentUpdateRequest,
  type DocumentContentMetadataDto,
  type DocumentContentMetadataCreateDto,
  type DocumentContentMetadataUpdateDto
} from './documentManagementSdk';

// UsersSdk exports
export {
  UsersSdk,
  type Department,
  type ApplicationPrivilege,
  type ResourcePrivilegeContext,
  type ResourcePrivilege,
  type UserPrivilegesResponse
} from './usersSdk';

// TranscriptMetaDataSdk exports
export { TranscriptMetaDataSdk } from './transcriptMetadataSdk';

// ConnectorSdk exports
export {
  ConnectorSdk,
  type ConnectorCourse,
  type ConnectorExportBase,
  type ConnectorExportRequest,
  type ConnectorHighSchoolExportRequest,
  type ConnectorInstitutionResult,
  type ConnectorExportResponse,
  type ConnectorExportRequirements
} from './connectorSdk';

// EtriveConnectSdk exports
export { EtriveConnectSdk, type ConnectSourceResponse } from './etriveConnectSdk';

// ITPIntegrationSourceSdk exports
export {
  ITPIntegrationSourceSdk,
  type SourcesResponse,
  type ITPIntegrationSourceCreate
} from './ITPIntegrationSourceSdk';

// ITPIntegrationStepSdk exports
export { ITPIntegrationStepSdk, type IntegrationStepDTO } from './ITPIntegrationStepSdk';

// ITPIntegrationCredentialSdk exports
export {
  ITPIntegrationCredentialSdk,
  type ITPIntegrationCredentials,
  type ITPIntegrationCredentialsResponse
} from './ITPIntegrationCredentialSdk';
